import Vue from "vue";
import VueRouter from "vue-router";

import Login from "./Pages/Login.vue";

import CompanyInfo from "./Pages/CompanyInfo.vue";
import Error from "./Pages/Error.vue";
import Block from "./Pages/Block.vue";
import Info from "./Pages/Info.vue";
import NotFound from "./Pages/NotFound.vue";
import ErrorGoodLimit from "./Pages/ErrorGoodLimit.vue";
import ErrorLookLimit from "./Pages/ErrorLookLimit.vue";
import ErrorLogin from "./Pages/ErrorLogin.vue";
import UserShow from "./Pages/User/Show.vue";
import Profile from "./Pages/Mypage/Profile.vue";
import Icon from "./Pages/Mypage/Icon.vue";
import Area from "./Pages/Mypage/Area.vue";
import MatchingGood from "./Pages/Matching/Good.vue";
import MatchingCongratulation from "./Pages/Matching/Congratulation.vue";
import MatchingCongratulationList from "./Pages/Matching/CongratulationList.vue";
import SettingIndex from "./Pages/Setting/Index.vue";
import SettingList from "./Pages/Setting/List.vue";
import SettingLogout from "./Pages/Setting/Logout.vue";
import SettingUnsubscribe from "./Pages/Setting/Unsubscribe.vue";
import SettingMail from "./Pages/Setting/Mail.vue";
import SettingPassword from "./Pages/Setting/Password.vue";
import SettingFootprintList from "./Pages/Setting/FootprintList.vue";
import SettingNotification from "./Pages/Setting/Notification.vue";
import SettingSearchView from "./Pages/Setting/SearchView.vue";
import AuthCheck from "./Pages/Auth/Check.vue";
import AuthModMail from "./Pages/Auth/ModMail.vue";
import AuthPassword from "./Pages/Auth/Password.vue";
import AuthPasswordSend from "./Pages/Auth/PasswordSend.vue";
import AuthPasswordMod from "./Pages/Auth/PasswordMod.vue";
import EventList from "./Pages/Event/List.vue";
import EventDetails from "./Pages/Event/Details.vue";
import EventRecruit from "./Pages/Event/Recruit.vue";
import EventReRecruit from "./Pages/Event/ReRecruit.vue";
import EventRecruitInfo from "./Pages/Event/RecruitInfo.vue";
import EventCompletion from "./Pages/Event/Completion.vue";
import EventCancel from "./Pages/Event/Cancel.vue";
import EventReset from "./Pages/Event/Reset.vue";
import EventEntryQuestion1 from "./Pages/Event/Entry/Question1.vue";
import EventEntryQuestion2 from "./Pages/Event/Entry/Question2.vue";
import EventEntryQuestion3 from "./Pages/Event/Entry/Question3.vue";
import EventEntryQuestion4 from "./Pages/Event/Entry/Question4.vue";
import EventEntryQuestion5 from "./Pages/Event/Entry/Question5.vue";
import EventHome from "./Pages/Event/Home.vue";
import EventSearch from "./Pages/Event/Search.vue";
import EventPickup from "./Pages/Event/Pickup.vue";
import EventAdminMod from "./Pages/Event/Admin/Mod.vue";
import EventAdminRm from "./Pages/Event/Admin/Rm.vue";
import EventAdminMailAdd from "./Pages/Event/Admin/MailAdd.vue";
import EventAdminMailList from "./Pages/Event/Admin/MailList.vue";
import EventAdminMemberList from "./Pages/Event/Admin/MemberList.vue";
import ShopList from "./Pages/Shop/List.vue";
import CardIndex from "./Pages/Card/Index.vue";
import CardDetail from "./Pages/Card/Detail.vue";
import CardMessageDetail from "./Pages/Card/MessageDetail.vue";
import CardCategory from "./Pages/Card/Category.vue";
import CardEntry from "./Pages/Card/Entry.vue";
import CardMod from "./Pages/Card/Mod.vue";
import CardSearch from "./Pages/Card/Search.vue";
import CardBookmark from "./Pages/Card/Bookmark.vue";
import CardNewList from "./Pages/Card/NewList.vue";
import CardPopularList from "./Pages/Card/PopularList.vue";
import ReportPage1 from "./Pages/Report/Page1.vue";
import ReportPage2 from "./Pages/Report/Page2.vue";
import ReportPage3 from "./Pages/Report/Page3.vue";
import ReportPage4 from "./Pages/Report/Page4.vue";
import ReportPage5 from "./Pages/Report/Page5.vue";
import PremiumMessageIndex from "./Pages/Matching/PremiumMessage/Index.vue";

Vue.use(VueRouter);

// React 側の frontend/src/lib/pageTitle.ts の DEFAULT_PAGE_TITLE と同じ値。片方だけ変えないこと。
const DEFAULT_PAGE_TITLE = "SMマッチングサイト Luna";

// app/Constants/PageMeta.php の ARTICLE_REPORT_URLS が正。片方だけ変えないこと。
const ARTICLE_REPORT_URLS = {
    page2:
        "https://smguide.luna-matching.com/1%e5%b9%b4%e3%82%82%e7%b5%8c%e3%81%9f%e3%81%9a%e3%81%ab%e8%89%af%e3%81%84%e5%be%93%e8%80%85%e3%81%ab%e5%87%ba%e4%bc%9a%e3%81%88%e3%80%81%e3%81%a8%e3%81%a6%e3%82%82%e5%b9%b8%e3%81%9b%e3%81%a7%e3%81%99/4509/",
    page3:
        "https://smguide.luna-matching.com/luna%e3%81%ab%e5%87%ba%e4%bc%9a%e3%81%a3%e3%81%a6%e4%ba%ba%e7%94%9f%e3%81%8c%e5%a4%a7%e3%81%8d%e3%81%8f%e5%a4%89%e3%82%8f%e3%82%8a%e3%81%be%e3%81%97%e3%81%9f%ef%bc%81/4519/",
    page4:
        "https://smguide.luna-matching.com/%e4%b9%9d%e5%b7%9e%e9%9b%a2%e5%b3%b6-x-%e6%a8%aa%e6%b5%9c%e3%81%ae1900km%e3%81%ae%e8%b6%85%e9%81%a0%e8%b7%9d%e9%9b%a2%e3%82%92%e4%b9%97%e3%82%8a%e8%b6%8a%e3%81%88-luna%e3%81%a7%e7%b5%90%e5%a9%9a/4496/",
    page5:
        "https://smguide.luna-matching.com/sm%e3%81%ae%e8%a9%b1%e3%81%af%e3%81%97%e3%81%aa%e3%81%8b%e3%81%a3%e3%81%9f%e3%81%ae%e3%81%ab%e8%87%aa%e7%84%b6%e3%81%a8%e6%83%b9%e3%81%8b%e3%82%8c%e5%90%88%e3%81%84%e3%80%81%e3%83%91%e3%83%bc/4522/",
};

const routes = [
    {
        // パスを変更する場合は、Flipdeskのタグ設置のパスの設定(resources/views/welcome.blade.php)も変更すること。
        // c.f https://www.notion.so/luna-matching/2483157283fc803084f5eb2d02c170c5
        path: "/login",
        name: "Login",
        component: Login,
    },
    {
        path: "/company/info",
        name: "CompanyInfo",
        component: CompanyInfo,
        meta: { title: "会社概要 | SMマッチングサイト Luna" },
    },
    {
        path: "/error",
        name: "Error",
        component: Error,
    },
    {
        path: "/block",
        name: "Block",
        component: Block,
    },
    {
        // パスを変更する場合は、Flipdeskのタグ設置のパスの設定(resources/views/welcome.blade.php)も変更すること。
        // c.f https://www.notion.so/luna-matching/2483157283fc803084f5eb2d02c170c5
        path: "/info",
        name: "Info",
        component: Info,
    },
    {
        path: "/error/good/limit",
        name: "ErrorGoodLimit",
        component: ErrorGoodLimit,
    },
    {
        path: "/error/look/limit",
        name: "ErrorLookLimit",
        component: ErrorLookLimit,
    },
    {
        // パスを変更する場合は、Flipdeskのタグ設置のパスの設定(resources/views/welcome.blade.php)も変更すること。
        // c.f https://www.notion.so/luna-matching/2483157283fc803084f5eb2d02c170c5
        path: "/error/login",
        name: "ErrorLogin",
        component: ErrorLogin,
    },
    // {
    //     path: "/plan",
    //     name: "PlanList",
    //     beforeEnter() {
    //         window.location.replace("/plan");
    //     },
    // },
    // {
    //     // パスを変更する場合は、Flipdeskのタグ設置のパスの設定(resources/views/welcome.blade.php)も変更すること。
    //     // c.f https://www.notion.so/luna-matching/2483157283fc803084f5eb2d02c170c5
    //     path: "/page/plan",
    //     name: "PlanListUnlogin",
    //     beforeEnter() {
    //         window.location.replace("/plan");
    //     },
    // },
    {
        path: "/profile",
        name: "Profile",
        component: Profile,
    },
    {
        path: "/user/icon",
        name: "Icon",
        component: Icon,
    },
    {
        path: "/user/area",
        name: "Area",
        component: Area,
    },
    {
        path: "/user/show/:uid/:type",
        name: "UserShow",
        component: UserShow,
    },
    {
        path: "/matching/good/:uid",
        name: "MatchingGood",
        component: MatchingGood,
    },
    {
        path: "/matching/congratulation/:uid",
        name: "MatchingCongratulation",
        component: MatchingCongratulation,
    },
    {
        // パスを変更する場合は、Flipdeskのタグ設置のパスの設定(resources/views/welcome.blade.php)も変更すること。
        // c.f https://www.notion.so/luna-matching/2483157283fc803084f5eb2d02c170c5
        path: "/congratulation/list",
        name: "MatchingCongratulationList",
        component: MatchingCongratulationList,
    },
    // PremiumMessage
    {
        path: "/premium/message",
        name: "PremiumMessageIndex",
        component: PremiumMessageIndex,
    },
    {
        path: "/setting",
        name: "SettingIndex",
        component: SettingIndex,
    },
    {
        path: "/setting/:page/list",
        name: "SettingList",
        component: SettingList,
    },
    {
        path: "/setting/logout",
        name: "SettingLogout",
        component: SettingLogout,
    },
    {
        path: "/setting/unsubscribe",
        name: "SettingUnsubscribe",
        component: SettingUnsubscribe,
    },
    {
        path: "/setting/mail",
        name: "SettingMail",
        component: SettingMail,
    },
    {
        path: "/setting/password",
        name: "SettingPassword",
        component: SettingPassword,
    },
    {
        path: "/footprint/list",
        name: "SettingFootprintList",
        component: SettingFootprintList,
    },
    {
        path: "/setting/notification",
        name: "SettingNotification",
        component: SettingNotification,
    },
    {
        path: "/setting/search/view",
        name: "SettingSearchView",
        component: SettingSearchView,
    },
    {
        path: "/auth/check",
        name: "AuthCheck",
        component: AuthCheck,
    },
    {
        path: "/auth/email/mod",
        name: "AuthModMail",
        component: AuthModMail,
    },
    {
        path: "/auth/password/reset",
        name: "AuthPassword",
        component: AuthPassword,
    },
    {
        path: "/auth/password/mod",
        name: "AuthPasswordMod",
        component: AuthPasswordMod,
    },
    {
        path: "/auth/password/send/:mail",
        name: "AuthPassword",
        component: AuthPasswordSend,
    },
    {
        path: "/event/list",
        name: "EventList",
        component: EventList,
    },
    {
        path: "/event/details/:eid",
        name: "EventDetails",
        component: EventDetails,
    },
    {
        path: "/event/recruit/:eid",
        name: "EventRecruit",
        component: EventRecruit,
    },
    {
        path: "/event/re/recruit/:eid",
        name: "EventReRecruit",
        component: EventReRecruit,
    },
    {
        path: "/event/member/:eid",
        name: "EventRecruitInfo",
        component: EventRecruitInfo,
    },
    {
        path: "/event/completion",
        name: "EventCompletion",
        component: EventCompletion,
    },
    {
        path: "/event/cancel",
        name: "EventCancel",
        component: EventCancel,
    },
    {
        path: "/event/reset",
        name: "EventReset",
        component: EventReset,
    },
    {
        path: "/event/entry/question1",
        name: "EventEntryQuestion1",
        component: EventEntryQuestion1,
    },
    {
        path: "/event/entry/question2",
        name: "EventEntryQuestion2",
        component: EventEntryQuestion2,
    },
    {
        path: "/event/entry/question3",
        name: "EventEntryQuestion3",
        component: EventEntryQuestion3,
    },
    {
        path: "/event/entry/question4",
        name: "EventEntryQuestion4",
        component: EventEntryQuestion4,
    },
    {
        path: "/event/entry/question5",
        name: "EventEntryQuestion5",
        component: EventEntryQuestion5,
    },
    {
        path: "/event/home",
        name: "EventHome",
        component: EventHome,
    },
    {
        path: "/event/search",
        name: "EventSearch",
        component: EventSearch,
    },
    {
        path: "/event/pickup/list",
        name: "EventPickup",
        component: EventPickup,
    },
    {
        path: "/event/admin/mod/:eid",
        name: "EventAdminMod",
        component: EventAdminMod,
    },
    {
        path: "/event/admin/rm/:eid",
        name: "EventAdminRm",
        component: EventAdminRm,
    },
    {
        path: "/event/admin/mail/add/:eid",
        name: "EventAdminMailAdd",
        component: EventAdminMailAdd,
    },
    {
        path: "/event/admin/mail/list/:eid",
        name: "EventAdminMailList",
        component: EventAdminMailList,
    },
    {
        path: "/event/admin/member/list/:eid",
        name: "EventAdminMemberList",
        component: EventAdminMemberList,
    },
    {
        path: "/shop/list",
        name: "ShopList",
        component: ShopList,
    },
    {
        path: "/card",
        name: "CardIndex",
        component: CardIndex,
    },
    {
        path: "/card/category/list",
        name: "CardCategory",
        component: CardCategory,
    },
    {
        path: "/card/entry",
        name: "CardEntry",
        component: CardEntry,
    },
    {
        path: "/card/mod/:cid",
        name: "CardMod",
        component: CardMod,
    },
    {
        path: "/card/search",
        name: "CardSearch",
        component: CardSearch,
    },
    {
        path: "/card/bookmark",
        name: "CardBookmark",
        component: CardBookmark,
    },
    {
        path: "/card/new/list",
        name: "CardNewList",
        component: CardNewList,
    },
    {
        path: "/card/popular/list",
        name: "CardPopularList",
        component: CardPopularList,
    },
    {
        path: "/card/detail/:cid",
        name: "CardDetail",
        component: CardDetail,
    },
    {
        path: "/card/message/detail/:cmid",
        name: "CardMessageDetail",
        component: CardMessageDetail,
    },
    // title / canonical をここにも持たせるのは、SPA 内遷移で前のページの値が残るのを防ぐため。
    // サーバー側 app/Constants/PageMeta.php が正なので、片方だけ変えないこと。
    {
        path: "/report/page1",
        name: "ReportPage1",
        component: ReportPage1,
        meta: {
            title:
                "縄の練習中だったからこそ、出会えたパートナー | マッチングレポート | " +
                DEFAULT_PAGE_TITLE,
        },
    },
    {
        path: "/report/page2",
        name: "ReportPage2",
        component: ReportPage2,
        meta: {
            title:
                "1年も経たずに良い従者に出会え、とても幸せです！ | マッチングレポート | " +
                DEFAULT_PAGE_TITLE,
            canonical: ARTICLE_REPORT_URLS.page2,
        },
    },
    {
        path: "/report/page3",
        name: "ReportPage3",
        component: ReportPage3,
        meta: {
            title:
                "Lunaに出会って人生が大きく変わりました！ | マッチングレポート | " +
                DEFAULT_PAGE_TITLE,
            canonical: ARTICLE_REPORT_URLS.page3,
        },
    },
    {
        path: "/report/page4",
        name: "ReportPage4",
        component: ReportPage4,
        meta: {
            title:
                "九州離島 × 横浜の1,900kmの超遠距離を乗り越え Lunaで結婚！ | マッチングレポート | " +
                DEFAULT_PAGE_TITLE,
            canonical: ARTICLE_REPORT_URLS.page4,
        },
    },
    {
        path: "/report/page5",
        name: "ReportPage5",
        component: ReportPage5,
        meta: {
            title:
                "SMの話はしなかったのに…自然と惹かれ合い、パートナーへ。 | マッチングレポート | " +
                DEFAULT_PAGE_TITLE,
            canonical: ARTICLE_REPORT_URLS.page5,
        },
    },
    {
        path: "*",
        name: "NotFound",
        component: NotFound,
    },
];

const router = new VueRouter({
    mode: "history",
    routes,
});

let isInitialNavigation = true;

/** サーバー側 canonical と揃えるため末尾スラッシュを落とす（"/" 自体は除く） */
function normalizePathname(pathname) {
    return pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
}

/**
 * SPA 内遷移後に canonical / description を作り直す。
 *
 * 初期表示はサーバーの値が正なので触らない。遷移後は「前のページの値が残る」ことだけ防げばよく、
 * クローラーは URL ごとに新しいページロードでレンダリングするため遷移後の DOM を見ない。
 * description はページ固有の長文をクライアントに複製したくないので、復元せず外すだけにする。
 *
 * @param {{title?: string, canonical?: string}|null} meta 遷移先ルートの meta。無ければ null
 */
function syncPageHeadAfterNavigation(meta) {
    const canonical = document.querySelector('link[rel="canonical"]');

    if (!meta) {
        if (canonical) canonical.remove();
    } else {
        // meta.canonical を見るのは、記事側など他サイトを正規とするページがあるため
        const href =
            meta.canonical ||
            window.location.origin + normalizePathname(window.location.pathname);

        if (canonical) {
            canonical.href = href;
        } else {
            const created = document.createElement("link");
            created.rel = "canonical";
            created.href = href;
            document.head.appendChild(created);
        }
    }

    const description = document.querySelector('meta[name="description"]');
    if (description) description.remove();
}

/**
 * SPA 内遷移後に document.title を遷移先の meta.title に差し替える。
 *
 * 初期表示でも走るが、サーバー側（app/Constants/PageMeta.php）が title を出すページには
 * 同じ値の meta.title を持たせてあるので同値の再代入になる。app.js を読み込む他の Blade
 * （card_template / event_template）の title も既定値と同じ。
 */
router.afterEach((to) => {
    // 一番深い階層で指定された meta.title を採る
    const matched = to.matched
        .slice()
        .reverse()
        .find((record) => record.meta && record.meta.title);

    document.title = matched ? matched.meta.title : DEFAULT_PAGE_TITLE;

    if (isInitialNavigation) {
        isInitialNavigation = false;
        return;
    }

    syncPageHeadAfterNavigation(matched ? matched.meta : null);
});

export default router;
